import { gql } from '@apollo/client'

export const GET_RES_CENTER_MIGRATION_BANNER = gql`
  query GetResCenterMigrationBanner {
    resCenterMigrationBanner {
      eligible
      help_article_url
      res_center_url
      forgot_password_url
      learn_more_clicked_at
      try_it_attempted_at
      try_it_succeeded_at
    }
  }
`
